import { useQuery } from "@tanstack/react-query";
import { getConfig } from "@/lib/api";

export const useConfig = () =>
  useQuery({ queryKey: ["config"], queryFn: getConfig, staleTime: 300_000 });
